import Phaser from "phaser";
import React, {
  useContext,
  useReducer,
  useCallback,
  useEffect,
  useState,
  useRef
} from "react";
import "./Game.css";
import * as log from "loglevel";
import axios from "axios";
import Player from "@vimeo/player";
import * as wordsObject from "./words";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import * as PIXI from "pixi.js";
import { sound } from "@pixi/sound";
import VideoGrid from "./comps/VideoGrid";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import packageJson from "../package.json";

const words = [];
Object.keys(wordsObject).forEach((key) => {
  words.push(wordsObject[`${key}`]);
});
log.setLevel(log.levels.DEBUG);

const gameCotextDefault = {
  actions: {
    replace: "replace",
    addAudio: "addAudio",
    addKeyoard: "addKeyoard"
  },
  inputs: {
    audio: [],
    keyboard: ""
  }
};

export const GameContext = React.createContext(gameCotextDefault);

const keys = {
  vimeo: "9ab390cbf108fdcff105609b9747ac4f"
};
export const getFnLib = () => {
  const searchVimeoVideos = async (qs) => {
    let res = await axios.get(`https://api.vimeo.com/videos${qs}`, {
      headers: {
        Authorization: `Bearer ${keys.vimeo}`
      }
    });
    log.debug("searchVimeoVideos", { res });
    if (res) {
      let vimeoData = res.data.data;
      return vimeoData;
    }
    return [];
  };
  return {
    searchVimeoVideos
  };
};
export const fnLib = getFnLib();

function RoundScreen(props) {
  const [timeLeft, setTimeLeft] = useState(null);
  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column"
      }}
    >
      {timeLeft !== 0 ? (
        <div
          style={{
            display: "flex",
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column"
          }}
        >
          <CountdownCircleTimer
            isPlaying
            duration={30}
            colors={[
              ["#004777", 0.33],
              ["#F7B801", 0.33],
              ["#A30000", 0.33]
            ]}
          >
            {({ remainingTime }) => {
              setTimeLeft(remainingTime);
              return <Typography variant="h1">{remainingTime}s</Typography>;
            }}
          </CountdownCircleTimer>
        </div>
      ) : null}
      <div
        style={{
          display: "flex",
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column"
        }}
      >
        <SpeechRecognizer timeLeft={timeLeft} />
        {(() => {
          if (timeLeft > 0) {
            return (
              <iframe
                src="https://giphy.com/embed/5q3NyUvgt1w9unrLJ9"
                width="240"
                height="240"
                frameBorder="0"
                class="giphy-embed"
                allowFullScreen
              ></iframe>
            );
          }
          return (
            <iframe
              src="https://giphy.com/embed/3ohryiYkE0DVwdLAys"
              width="240"
              height="240"
              frameBorder="0"
              class="giphy-embed"
              allowFullScreen
            ></iframe>
          );
        })()}
        <TextRecorder />
        {timeLeft === 0 ? (
          <Button
            onClick={() => {
              const event = new CustomEvent("game", {
                detail: {
                  type: "navigation",
                  navigation: {
                    destination: "score"
                  }
                }
              });
              // Dispatch the event.
              window.dispatchEvent(event);
            }}
          >
            <Typography variant="h5">
              Publish your last blog post and call your boss.
            </Typography>
          </Button>
        ) : null}
      </div>
    </div>
  );
}

function TextRecorder(props) {
  const [buffer, setBuffer] = useState([]);
  const gameContext = useContext(GameContext);
  useEffect(() => {
    gameContext.dispatch({
      type: gameContext.actions.addKeyoard,
      payload: {
        buffer
      }
    });
  }, [buffer]);
  useEffect(() => {
    const onKeyUp = (e) => {
      // log.debug("keyboard debug", e);
      setBuffer((p) => [...p, e.key]);
    };
    window.addEventListener("keyup", onKeyUp);
    return () => {
      window.removeEventListener("keyup", onKeyUp);
    };
  }, []);
  return null;
}

function SpeechRecognizer(props) {
  const [isRecording, setIsRecording] = useState(false);
  const [recognition, setRecognition] = useState(false);
  const gameContext = useContext(GameContext);
  useEffect(() => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    const SpeechGrammarList =
      window.SpeechGrammarList || window.webkitSpeechGrammarList;
    const SpeechRecognitionEvent =
      window.SpeechRecognitionEvent || window.webkitSpeechRecognitionEvent;
    const grammarWords = [...words];
    var grammar =
      "#JSGF V1.0; grammar colors; public <color> = aqua | azure | beige | bisque | black | blue | brown | chocolate | coral | crimson | cyan | fuchsia | ghostwhite | gold | goldenrod | gray | green | indigo | ivory | khaki | lavender | lime | linen | magenta | maroon | moccasin | navy | olive | orange | orchid | peru | pink | plum | purple | red | salmon | sienna | silver | snow | tan | teal | thistle | tomato | turquoise | violet | white | yellow ;";

    const recognition = new SpeechRecognition();
    let speechRecognitionList = new SpeechGrammarList();
    speechRecognitionList.addFromString(grammar, 1);
    recognition.grammars = speechRecognitionList;
    recognition.continuous = true;
    recognition.lang = "en-US";
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;
    console.log("SpeechRecognizer", {
      SpeechRecognition,
      SpeechGrammarList,
      SpeechRecognitionEvent,
      grammarWords,
      grammar,
      recognition,
      speechRecognitionList
    });

    recognition.onresult = function (event) {
      log.debug("Speech result.", event);
      Object.keys(event.results).forEach((key) => {
        Object.keys(event.results[key]).forEach((innerKey) => {
          const word = event.results[key][innerKey].transcript;
          log.debug(
            `Word: ${word}. Confidence: ` +
              event.results[key][innerKey].confidence
          );
          gameContext.dispatch({
            type: gameContext.actions.addAudio,
            payload: {
              word
            }
          });
        });
      });
    };
    recognition.onspeechend = function (e) {
      setIsRecording(false);
      log.debug("Speech ended.", e);
    };
    setRecognition(recognition);
  }, []);
  return (
    <div>
      {props.timeLeft !== 0 ? (
        <div style={{ textAlign: "center" }}>
          <Typography variant="h5">
            Speak or Type. We will do the rest.
          </Typography>
        </div>
      ) : null}
      <br />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {props.timeLeft !== 0 ? (
          <Button
            onClick={() => {
              if (isRecording === false) {
                try {
                  recognition.start();
                  setIsRecording(true);
                } catch (e) {
                  log.error("recognition start/stop error", e.message);
                }
              } else {
                try {
                  recognition.stop();
                  setIsRecording(false);
                } catch (e) {
                  log.error("recognition start/stop error", e.message);
                }
              }
            }}
          >
            <Typography variant="h2">
              {isRecording ? "Stop Recording" : "Start Recording"}
            </Typography>
          </Button>
        ) : null}
      </div>
      <div className="output"></div>
      <div className="hints"></div>
    </div>
  );
}

function GameManager(props) {
  const [screens, setScreens] = useState([]);
  const [currentScreen, setCurrentScreen] = useState(0);

  useEffect(() => {
    // audio
    sound.add("soundtrack", `/assets/piano.mp3`);
    log.debug("sound debug", sound);
    if (sound._sounds.soundtrack.isPlaying === false) {
      sound.play("soundtrack");
    }
    return () => {
      if (sound) {
        sound._sounds.soundtrack.stop();
      }
    };
  }, []);

  const welcomeScreen = (
    <div
      style={{
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column"
      }}
    >
      <iframe
        src="https://giphy.com/embed/XpizbEHNKqVUyuZTFc"
        width="480"
        height="349"
        frameBorder="0"
        class="giphy-embed"
        allowFullScreen
      ></iframe>
      <Typography variant="h1">Angry Boss</Typography>
      <div>{packageJson.version}</div>
      <Typography variant="h4">
        Your last day as a professional blogger
      </Typography>
      <Button
        onClick={() => {
          const event = new CustomEvent("game", {
            detail: {
              type: "navigation",
              navigation: {
                destination: "story"
              }
            }
          });
          // Dispatch the event.
          window.dispatchEvent(event);
        }}
      >
        <Typography variant="h6">Start the Game</Typography>
      </Button>
    </div>
  );
  const roundScreen = <RoundScreen />;
  const screenStyle = {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    height: "100%",
    color: "white"
  };
  const screenWrapper = (comp) => (
    <div className="screen-wrapper" style={screenStyle}>
      {comp}
    </div>
  );

  useEffect(() => {
    const onGameEvent = (e) => {
      log.debug("got game event", e);
      if (e.detail && e.detail.type === "navigation") {
        log.debug("finding screen", { screens, e });
        let index = 0;
        screens.forEach((s, i) => {
          if (s.name === e.detail.navigation.destination) {
            log.debug("selecting screen", s);
            index = i;
          }
        });
        setCurrentScreen(index);
      }
    };
    window.addEventListener("game", onGameEvent);
    return () => {
      window.removeEventListener("game", onGameEvent);
    };
  }, [screens]);

  useEffect(() => {
    // subscribe to the game events
    setScreens([
      {
        name: "main",
        component: screenWrapper(welcomeScreen)
      },
      {
        name: "story",
        component: screenWrapper(
          <div
            style={{
              display: "flex",
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column"
            }}
          >
            <Typography variant="h1"></Typography>
            <iframe
              src="https://giphy.com/embed/l41lO8vRXzSB0CkqQ"
              width="480"
              height="346"
              frameBorder="0"
              class="giphy-embed"
              allowFullScreen
            ></iframe>
            <Typography
              variant="h5"
              style={{ margin: "15px", textAlign: "center" }}
            >
              You are e lazy blogger.
              <br />
              You just got fired because your boss is not happy with your work.
              <br />
              You begged him for a last chance to impress him.{" "}
              <span style={{ color: "green" }}>
                Make the blog with the most views
              </span>{" "}
              of your entire career and keep the job!
            </Typography>
            <Button
              onClick={() => {
                const event = new CustomEvent("game", {
                  detail: {
                    type: "navigation",
                    navigation: {
                      destination: "round"
                    }
                  }
                });
                // Dispatch the event.
                window.dispatchEvent(event);
              }}
            >
              <Typography variant="h4">Got it!</Typography>
            </Button>
          </div>
        )
      },
      {
        name: "round",
        component: screenWrapper(
          <div
            style={{
              display: "flex",
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column"
            }}
          >
            {roundScreen}
          </div>
        )
      },
      {
        name: "score",
        component: screenWrapper(
          <div
            style={{
              display: "flex",
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column"
            }}
          >
            <VideoGrid words={["cat"]} />
            <Button
              onClick={() => {
                window.location.reload();
              }}
            >
              Replay
            </Button>
          </div>
        )
      }
    ]);
    setCurrentScreen(0);
  }, []);

  if (screens[currentScreen]) {
    return <React.Fragment>{screens[currentScreen].component}</React.Fragment>;
  }
  return <LinearProgress />;
}

const reducer = (prevState, action) => {
  const fnName = "Gotit";
  log.debug(`${fnName} - reducer ${action.type} - old state`, {
    prevState,
    action
  });
  if (action.type === gameCotextDefault.actions.replace) {
    const newState = {
      ...prevState,
      ...action.payload
    };
    log.debug(`${fnName} - reducer ${action.type} - new state`, {
      action,
      prevState,
      newState
    });
    return newState;
  }
  if (action.type === gameCotextDefault.actions.addAudio) {
    const newState = {
      ...prevState,
      inputs: {
        ...prevState.inputs,
        audio: [...prevState.inputs.audio, action.payload.word]
      }
    };
    log.debug(`${fnName} - reducer ${action.type} - new state`, {
      action,
      prevState,
      newState
    });
    return newState;
  }
  if (action.type === gameCotextDefault.actions.addKeyoard) {
    const newState = {
      ...prevState,
      inputs: {
        ...prevState.inputs,
        keyboard: action.payload.buffer.join("")
      }
    };
    log.debug(`${fnName} - reducer ${action.type} - new state`, {
      action,
      prevState,
      newState
    });
    return newState;
  }
  throw new Error(`cannot handle action in reducer: ${JSON.stringify(action)}`);
};
export default function Game() {
  const [state, dispatch] = useReducer(reducer, gameCotextDefault);
  useEffect(() => {
    dispatch({
      type: state.actions.replace,
      payload: {
        dispatch: dispatch,
        version: 1
      }
    });
  }, []);
  return (
    <GameContext.Provider value={state}>
      <GameManager />
    </GameContext.Provider>
  );
}
